/* AspiraGo — interacciones y animaciones (vanilla, sin librerías) */
(function () {
  document.documentElement.classList.add('ag-js');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* Titulares en palabras con máscara */
  function initSplit(root) {
    root.querySelectorAll('[data-ag-split]:not(.ag-split)').forEach(function (el) {
      var i = 0;
      (function walk(node) {
        Array.prototype.slice.call(node.childNodes).forEach(function (n) {
          if (n.nodeType === 3) {
            var frag = document.createDocumentFragment();
            n.textContent.split(/(\s+)/).forEach(function (part) {
              if (!part) return;
              if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(' ')); return; }
              var w = document.createElement('span'); w.className = 'ag-w';
              var s = document.createElement('span'); s.textContent = part; s.style.setProperty('--i', i++);
              w.appendChild(s); frag.appendChild(w);
            });
            n.parentNode.replaceChild(frag, n);
          } else if (n.nodeType === 1 && n.tagName !== 'BR') {
            if (n.tagName === 'EM') {
              var w = document.createElement('span'); w.className = 'ag-w';
              var s = document.createElement('span'); s.style.setProperty('--i', i++);
              n.parentNode.insertBefore(w, n); s.appendChild(n); w.appendChild(s);
            } else walk(n);
          }
        });
      })(el);
      el.classList.add('ag-split');
    });
  }

  /* Revelado al entrar en pantalla (un solo observer) */
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('ag-is-in');
        if (e.target.hasAttribute('data-ag-count')) countUp(e.target);
        io.unobserve(e.target);
      }
    });
  }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 }) : null;

  function initReveal(root) {
    root.querySelectorAll('[data-ag-reveal],[data-ag-split],[data-ag-count],[data-ag-inview]').forEach(function (el) {
      if (!io || reduce) { el.classList.add('ag-is-in'); if (el.hasAttribute('data-ag-count')) el.textContent = fmt(el); return; }
      io.observe(el);
    });
  }

  /* Respaldo: si el observer no dispara, revela lo que ya está en pantalla */
  function sweep() {
    var vh = window.innerHeight;
    document.querySelectorAll('[data-ag-reveal]:not(.ag-is-in),[data-ag-split]:not(.ag-is-in),[data-ag-count]:not(.ag-is-in),[data-ag-inview]:not(.ag-is-in)').forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < vh * 0.94 && r.bottom > 0) {
        el.classList.add('ag-is-in');
        if (el.hasAttribute('data-ag-count')) countUp(el);
        if (io) io.unobserve(el);
      }
    });
  }

  /* Cifras animadas */
  function fmt(el, v) {
    var to = parseFloat(el.getAttribute('data-ag-count')) || 0;
    var dec = parseInt(el.getAttribute('data-dec') || '0', 10);
    var n = v === undefined ? to : v;
    var s = n.toFixed(dec).split('.');
    s[0] = s[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return s.join(',');
  }
  function countUp(el) {
    if (reduce) { el.textContent = fmt(el); return; }
    var to = parseFloat(el.getAttribute('data-ag-count')) || 0, t0 = null, dur = 1800;
    function step(t) {
      if (!t0) t0 = t;
      var p = Math.min((t - t0) / dur, 1), e = 1 - Math.pow(1 - p, 4);
      el.textContent = fmt(el, to * e);
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  /* Parallax suave (hero / cta) */
  var par = [];
  function initParallax(root) {
    root.querySelectorAll('[data-ag-parallax]').forEach(function (el) { par.push(el); });
  }
  var ticking = false;
  function onScroll() {
    if (ticking) return; ticking = true;
    requestAnimationFrame(function () {
      var vh = window.innerHeight;
      par.forEach(function (el) {
        var r = el.parentElement.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        var k = parseFloat(el.getAttribute('data-ag-parallax')) || 0;
        var c = (r.top + r.height / 2 - vh / 2) / vh;
        el.style.transform = 'translate3d(0,' + (c * k * -100).toFixed(1) + 'px,0)';
      });
      document.querySelectorAll('.ag-uses__track').forEach(updateProgress);
      sweep();
      ticking = false;
    });
  }

  /* Escena sticky: la imagen cambia según el paso visible */
  function initScene(root) {
    root.querySelectorAll('[data-ag-scene]').forEach(function (sc) {
      if (sc._ag) return; sc._ag = 1;
      var steps = sc.querySelectorAll('.ag-scene__step');
      var imgs = sc.querySelectorAll('.ag-scene__img');
      var dots = sc.querySelectorAll('.ag-scene__count span');
      function set(i) {
        steps.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
        imgs.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
        dots.forEach(function (s, k) { s.classList.toggle('is-active', k <= i); });
      }
      set(0);
      if (!('IntersectionObserver' in window)) return;
      var o = new IntersectionObserver(function (en) {
        en.forEach(function (e) { if (e.isIntersecting) set(Array.prototype.indexOf.call(steps, e.target)); });
      }, { rootMargin: '-45% 0px -45% 0px' });
      steps.forEach(function (s) { o.observe(s); });
    });
  }

  /* Carrusel de usos: flechas, arrastre, progreso, inclinación */
  function updateProgress(tr) {
    var bar = tr.parentElement.parentElement.querySelector('.ag-progress span');
    if (!bar) return;
    var max = tr.scrollWidth - tr.clientWidth;
    var p = max > 0 ? tr.scrollLeft / max : 1;
    bar.style.setProperty('--p', (0.18 + p * 0.82).toFixed(3));
  }
  function initUses(root) {
    root.querySelectorAll('[data-ag-uses]').forEach(function (s) {
      if (s._ag) return; s._ag = 1;
      var tr = s.querySelector('.ag-uses__track');
      if (!tr) return;
      var card = function () { var c = tr.querySelector('.ag-use'); return c ? c.getBoundingClientRect().width + 20 : 320; };
      s.querySelectorAll('[data-dir]').forEach(function (b) {
        b.addEventListener('click', function () { tr.scrollBy({ left: card() * parseInt(b.getAttribute('data-dir'), 10), behavior: 'smooth' }); });
      });
      tr.addEventListener('scroll', function () { updateProgress(tr); }, { passive: true });
      updateProgress(tr);
      if (fine) {
        var down = false, x0 = 0, l0 = 0, moved = 0;
        tr.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse') return; down = true; moved = 0; x0 = e.clientX; l0 = tr.scrollLeft; tr.classList.add('is-drag'); });
        window.addEventListener('pointermove', function (e) { if (!down) return; moved = Math.abs(e.clientX - x0); tr.scrollLeft = l0 - (e.clientX - x0); });
        window.addEventListener('pointerup', function () { if (!down) return; down = false; tr.classList.remove('is-drag'); });
        tr.addEventListener('click', function (e) { if (moved > 6) { e.preventDefault(); e.stopPropagation(); } }, true);
        tr.addEventListener('dragstart', function (e) { e.preventDefault(); });
      }
    });
  }

  /* Inclinación 3D sutil al pasar el ratón */
  function initTilt(root) {
    if (!fine || reduce) return;
    root.querySelectorAll('[data-ag-tilt]').forEach(function (el) {
      if (el._ag) return; el._ag = 1;
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
        el.style.setProperty('--ry', (x * 8).toFixed(2) + 'deg');
        el.style.setProperty('--rx', (y * -8).toFixed(2) + 'deg');
      });
      el.addEventListener('pointerleave', function () { el.style.setProperty('--ry', '0deg'); el.style.setProperty('--rx', '0deg'); });
    });
  }

  /* Pestañas de accesorios con avance automático */
  function initTabs(root) {
    root.querySelectorAll('[data-ag-tabs]').forEach(function (s) {
      if (s._ag) return; s._ag = 1;
      var tabs = s.querySelectorAll('.ag-tab'), imgs = s.querySelectorAll('.ag-acc__img');
      var auto = s.getAttribute('data-auto') === 'true';
      var cur = 0;
      function set(i) {
        imgs.forEach(function (im, k) { im.classList.remove('was-active'); if (k === cur && k !== i) im.classList.add('was-active'); });
        cur = i;
        tabs.forEach(function (t, k) { t.classList.remove('is-active'); void t.offsetWidth; t.classList.toggle('is-active', k === i); t.setAttribute('aria-selected', k === i); });
        imgs.forEach(function (im, k) { im.classList.toggle('is-active', k === i); });
      }
      tabs.forEach(function (t, k) {
        t.addEventListener('click', function () { set(k); });
        var bar = t.querySelector('.ag-tab__bar');
        if (bar) bar.addEventListener('animationend', function () { if (auto) set((cur + 1) % tabs.length); });
      });
      if (!auto) s.style.setProperty('--ag-auto', '0s');
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (en) { en.forEach(function (e) { s.classList.toggle('is-paused', !e.isIntersecting); }); }).observe(s);
      }
      s.addEventListener('pointerenter', function () { s.classList.add('is-paused'); });
      s.addEventListener('pointerleave', function () { s.classList.remove('is-paused'); });
      set(0);
    });
  }

  /* Acordeones con altura animada */
  function initAccordion(root) {
    root.querySelectorAll('details.ag-q').forEach(function (d) {
      if (d._ag) return; d._ag = 1;
      var sum = d.querySelector('summary'), body = d.querySelector('.ag-q__a');
      if (!sum || !body || reduce) return;
      sum.addEventListener('click', function (e) {
        e.preventDefault();
        if (d.open) {
          body.animate([{ height: body.offsetHeight + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 420, easing: 'cubic-bezier(.65,0,.35,1)' }).onfinish = function () { d.open = false; };
          d.classList.remove('is-open');
        } else {
          var group = d.getAttribute('data-group');
          if (group) document.querySelectorAll('details.ag-q[data-group="' + group + '"][open]').forEach(function (o) { if (o !== d) o.querySelector('summary').click(); });
          d.open = true;
          var h = body.offsetHeight;
          body.animate([{ height: '0px', opacity: 0 }, { height: h + 'px', opacity: 1 }], { duration: 520, easing: 'cubic-bezier(.22,1,.36,1)' });
        }
      });
    });
  }

  /* Puntos interactivos (hotspots) en táctil */
  function initHot(root) {
    root.querySelectorAll('.ag-hot__dot').forEach(function (b) {
      if (b._ag) return; b._ag = 1;
      b.addEventListener('click', function () { b.parentElement.classList.toggle('is-open'); });
    });
  }

  /* Galería de producto */
  function initGallery(root) {
    root.querySelectorAll('[data-ag-gallery]').forEach(function (g) {
      if (g._ag) return; g._ag = 1;
      var slides = g.querySelector('.ag-gal__slides');
      var thumbs = g.querySelectorAll('.ag-gal__thumb'), dots = g.querySelectorAll('.ag-gal__dots span');
      if (!slides) return;
      function mark(i) {
        thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
        dots.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      }
      thumbs.forEach(function (t, k) {
        t.addEventListener('click', function () { slides.scrollTo({ left: slides.clientWidth * k, behavior: 'smooth' }); mark(k); });
      });
      slides.addEventListener('scroll', function () { mark(Math.round(slides.scrollLeft / slides.clientWidth)); }, { passive: true });
      mark(0);
    });
  }

  /* Barra de compra fija cuando el botón principal sale de pantalla */
  function initStickyBuy(root) {
    var bar = root.querySelector('[data-ag-sticky]'), target = root.querySelector('[data-ag-buy]');
    if (!bar || !target || !('IntersectionObserver' in window)) return;
    var foot = document.querySelector('.ag-foot');
    var past = false, footIn = false;
    function upd() { var on = past && !footIn; bar.classList.toggle('is-on', on); document.documentElement.classList.toggle('ag-sticky-on', on); }
    new IntersectionObserver(function (en) { en.forEach(function (e) { past = !e.isIntersecting && e.boundingClientRect.top < 0; upd(); }); }).observe(target);
    if (foot) new IntersectionObserver(function (en) { en.forEach(function (e) { footIn = e.isIntersecting; upd(); }); }).observe(foot);
  }

  /* Selector de variantes */
  function initVariants(root) {
    root.querySelectorAll('form.ag-form').forEach(function (form) {
      if (form._ag) return; form._ag = 1;
      var json = form.querySelector('script[type="application/json"]');
      if (!json) return;
      var variants = JSON.parse(json.textContent);
      var selects = form.querySelectorAll('select[data-opt]');
      var input = form.querySelector('input[name="id"]');
      var scope = form.closest('.ag-pdp') || document;
      selects.forEach(function (sel) {
        sel.addEventListener('change', function () {
          var vals = Array.prototype.map.call(selects, function (s) { return s.value; });
          var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === vals[i]; }); });
          var btns = scope.querySelectorAll('[data-ag-submit]');
          if (!v) { btns.forEach(function (b) { b.disabled = true; }); return; }
          input.value = v.id;
          scope.querySelectorAll('[data-ag-price]').forEach(function (p) { p.textContent = v.price_f; });
          scope.querySelectorAll('[data-ag-was]').forEach(function (p) { p.textContent = v.compare_f || ''; p.style.display = v.compare_f ? '' : 'none'; });
          btns.forEach(function (b) { b.disabled = !v.available; var l = b.querySelector('[data-label]'); if (l) l.textContent = v.available ? l.getAttribute('data-label') : l.getAttribute('data-soldout'); });
        });
      });
    });
  }

  /* Títulos de las políticas en español (Shopify los genera en el idioma principal) */
  function initPolicyTitles() {
    var h = document.querySelector('.shopify-policy__title h1');
    if (!h) return;
    var map = { 'shipping-policy': 'Política de envíos', 'refund-policy': 'Cambios y devoluciones', 'privacy-policy': 'Política de privacidad', 'terms-of-service': 'Términos del servicio', 'contact-information': 'Información de contacto', 'legal-notice': 'Aviso legal' };
    Object.keys(map).forEach(function (k) { if (location.pathname.indexOf('/policies/' + k) > -1) h.textContent = map[k]; });
    h.style.visibility = 'visible';
  }

  function init(root) {
    if (!root || root === document) initPolicyTitles();
    root = root || document;
    initSplit(root); initReveal(root); initParallax(root); initScene(root); initUses(root);
    initTilt(root); initTabs(root); initAccordion(root); initHot(root); initGallery(root);
    initStickyBuy(root); initVariants(root);
    onScroll();
    setTimeout(sweep, 1200);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);

  /* Editor de Shopify: re-inicializar al añadir o editar secciones */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
